import React from "react";
import { Col, Row } from "react-bootstrap";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import RequestFund from "./RequestFund";
import Report from "./Report";
import { useSelector } from "react-redux";
var PaymentlinkTabs = function (props) {
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-0 mx-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.setpaymentlinkshow(false);
                            } }),
                        "Payment Link -\u00A0",
                        React.createElement("span", { className: "EncodeSans_20_700" },
                            "Accode\u00A0:", selectedAcount === null || selectedAcount === void 0 ? void 0 :
                            selectedAcount.accountCode)))),
            React.createElement(Row, { className: "px-0 mx-0 payment-popuptable-block" },
                React.createElement(Row, { className: "mx-0 payment-generictabs-block" },
                    React.createElement(GenericTabs, { externalClassName: "common-tab-color client-tabs", defaultActiveKey: "client", tabsArray: [
                            {
                                title: "Request Fund from client",
                                eventKey: "client",
                                value: "client",
                                tabContent: React.createElement(RequestFund, null),
                            },
                            {
                                title: "Report",
                                eventKey: "report",
                                value: "report",
                                tabContent: React.createElement(Report, null),
                            },
                        ] }))))));
};
export default PaymentlinkTabs;
